var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmIcon01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(-1239 -1414)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1239 1414)",
    fill: "#fd0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26855",
    "data-name": "Path 26855",
    d: "M74.579-31.028l.59-3.944H71.485v-2.56a1.946,1.946,0,0,1,2.164-2.131h1.675v-3.359a19.938,19.938,0,0,0-2.974-.266c-3.035,0-5.018,1.889-5.018,5.308v3.007H63.96v3.944h3.373v9.535a13.026,13.026,0,0,0,2.076.166,13.026,13.026,0,0,0,2.076-.166v-9.535Z",
    transform: "translate(1185.04 1462.288)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmIcon01);
export default __webpack_public_path__ + "static/media/sm-icon-01.036db97a07a276cb588dbba38cd85207.svg";
export { ForwardRef as ReactComponent };